export default __webpack_public_path__ + "static/media/Version (7) - Snape Insult_05.7178250a.jpg";